import { Moon, Sun } from "lucide-react";
import { Button } from "../ui/button";
import { useTheme } from "./ThemeProvider";
import { cn } from "../../lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

// EF-ONBOARDING-INVITATION-AND-BUILD-THEME-FIX-V1: Fixed theme toggle to use correct context method
export function ThemeToggle({ compact = false, inverted = false }) {
  const { effectiveMode, toggleMode } = useTheme();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleMode}
            className={cn(
              "rounded-full transition-colors",
              compact ? "h-7 w-7" : "h-9 w-9",
              inverted && "text-white hover:bg-white/10"
            )}
            data-testid="theme-toggle-btn"
          >
            {effectiveMode === "dark" ? (
              <Sun className={cn(
                "text-yellow-400 transition-all",
                compact ? "h-4 w-4" : "h-5 w-5"
              )} />
            ) : (
              <Moon className={cn(
                "transition-all",
                compact ? "h-4 w-4" : "h-5 w-5",
                inverted ? "text-foreground" : "text-muted-foreground"
              )} />
            )}
            <span className="sr-only">Toggle theme</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Switch to {effectiveMode === "dark" ? "light" : "dark"} mode</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
